// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__hPnZs","title":"ClientReferral_title__1Y4CS","itemText":"ClientReferral_itemText__1KDzG"};